/**
 * VFlowContainer registration: FlowContainer's parser, since the two read every key the same way.
 * Render wiring lives in `./index.r3f`.
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseFlowContainer } from '../flowcontainer/parser';
const vFlowContainerRegistration = {
    typeName: 'VFlowContainer',
    parser: parseFlowContainer,
};
nodeRegistry.register(vFlowContainerRegistration);
//# sourceMappingURL=index.js.map